import { createPortal } from 'react-dom';
import React, { useContext, useEffect, useState, useRef } from 'react';
import { Dialog, DialogActions, DialogContent, withStyles } from '@material-ui/core';
import DataContext from '../data/DataContext';
import SatisfiedOn from '../../asset/img/ic-good-sel.svg';
import SatisfiedOff from '../../asset/img/ic-good-nor.svg';
import UnsatisfiedOn from '../../asset/img/ic-bad-sel.svg';
import UnsatisfiedOff from '../../asset/img/ic-bad-nor.svg';
import StarNormal from '../../asset/img/ico-star.svg';
import StarSelected from '../../asset/img/ico-star-full.svg';
import StarHalf from '../../asset/img/ico-star-half.svg';
import StarHalfLeft from '../../asset/img/ico-star-half-left.svg';
import CounterPlus from '../../asset/img/ico-counter-plus.svg';
import CounterMinus from '../../asset/img/ico-counter-minus.svg';
import ToggleInput from '../../asset/img/btn_resend.svg';
import { Rating } from '@material-ui/lab';
import { postLog } from '../data/DataLoader';
// import StarRating from './StarRating';
import NpsRating from './NpsRating';

const styles = (theme) => ({
  root: {
    display: 'flex',
  },
  dialogRoot: {
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    position: 'fixed',
    zIndex: '1300',
    inset: '0px',
  },
  dialogContainer: {
    height: 'fit-content',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  dialogBody: {
    borderRadius: '0.625rem',
    margin: '0',
    width: '90%',
    maxHeight: 'none',
    background: '#fff',
    maxWidth: '600px',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    overflowY: 'auto',
    boxShadow:
      '0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
  },
  dialogContent: {
    padding: '1.25rem',
  },
  dialogContainerBackdrop: {
    opacity: '1',
    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1)',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    display: 'flex',
    zIndex: '-1',
    position: 'fixed',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  },
  divider: {
    color: '#ccc',
  },
  title: {
    fontSize: theme.font.size18,
    color: theme.color.text_color.black,
    fontWeight: 'bold',
    // minHeight: "54px",
    padding: '1.875rem 1.25rem 0 1.25rem',
    display: 'flex',
    alignItems: 'center',
    margin: '0rem',
  },
  question: {
    color: theme.color.text_color.black,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
  },
  questionMargin: {
    margin: '1.5rem 0 0 0',
  },
  lastQuestionContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  toggleInput: {
    fontSize: theme.font.size12,
    fontWeight: 'bold',
    lineHeight: '1.25',
    color: theme.color.text_color.red,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: 'none',
    background: 'transparent',
  },
  toggleIcon: {
    marginRight: '0.25rem',
  },
  satisfiedContainer: {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#f6f6f6',
    borderRadius: '0.375rem',
    margin: '0.75rem 0 0 0',

    // padding: "14px 0px",
  },
  buttonSatisfed: {
    width: '100%',
    height: '2.5rem',
    // outline: "none",
    border: 0,
    borderRadius: '0.375rem',
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    background: 'transparent',
    fontWeight: 'bold',
    fontSize: theme.font.size14,
    lineHeight: '1.07',
    textAlign: 'center',

    // margin: "4px 0px",
    // padding: "0px 4px",
  },
  buttonSatisfedOn: {
    background: theme.color.button.background_white,
    color: theme.color.text_color.black,
    border: `solid 1px ${theme.color.text_color.black}`,
  },
  buttonSatisfedOff: {
    background: '#f6f6f6',
    color: theme.color.title,
    border: '0',
  },
  iconSatisfied: {
    width: '2rem',
    height: '2rem',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '2rem',
    margin: '0px 0.75rem',
  },
  iconSatisfiedOn: {
    backgroundImage: `url(${SatisfiedOn})`,
  },
  iconSatisfiedOff: {
    backgroundImage: `url(${SatisfiedOff})`,
  },
  iconUnsatisfiedOn: {
    backgroundImage: `url(${UnsatisfiedOn})`,
  },
  iconUnsatisfiedOff: {
    backgroundImage: `url(${UnsatisfiedOff})`,
  },
  ratingContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    // paddingTop: "20px",
    background: '#f6f6f6',
    borderRadius: '0.375rem',
    margin: '0.75rem 0 0 0',
    padding: '1rem 0',
  },
  ratingString: {
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    color: '#000',
    width: '1.25rem',
    textAlign: 'center',
  },
  starNormal: {
    width: '2rem',
    height: '2rem',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '2rem',
    backgroundImage: `url(${StarNormal})`,
  },
  starSelected: {
    width: '2rem',
    height: '2rem',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '2rem',
    backgroundImage: `url(${StarSelected})`,
  },
  button: {
    // outline: "none",
    border: 'none',
    height: '3.125rem',
    width: '100%',
  },
  buttonSubmit: {
    background: theme.color.button.background_red,
    color: theme.color.button.text_white,
    borderRadius: '0.375rem',
    fontWeight: 'bold',
    lineHeight: '1.43',
    fontSize: theme.font.size14,
  },
  buttonDiscard: {
    background: theme.color.button.background_white,
    color: '#333',
    fontWeight: 'bold',
    lineHeight: '1.43',
    fontSize: theme.font.size14,
    marginTop: '0.375rem',
  },
  feedbackInputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '0.375rem',
  },
  fbBut: {
    textAlign: 'center',
    borderRadius: '0.375rem',
    width: '100%',
    height: '2.5rem',
    padding: '0.625rem 0',
    marginTop: '0.375rem',
  },
  fbButSelected: {
    background: theme.color.button.background_white,
    border: `solid 0.0625rem ${theme.color.text_color.black}`,
    fontSize: theme.font.size14,
    fontWeight: 'bold',
    lineHeight: '1.14',
    letterSpacing: 'normal',
    color: theme.color.text_color.black,
  },
  fbButNotSelected: {
    background: '#f6f6f6',
    border: `0`,

    fontSize: theme.font.size14,
    fontWeight: 'normal',
    lineHeight: '1.07',
    letterSpacing: 'normal',
    color: theme.color.text_color.black,
  },
  directInputBox: {
    width: '100%',
    height: '8.25rem',
    padding: '0.8125rem 1rem',
    position: 'relative',
    border: 'solid 0.0625rem #929292',
    background: theme.color.button.background_white,
    borderRadius: '0.375rem',
    marginTop: '0.375rem',
  },
  directInputStyle: {
    resize: 'none',
    // outline: "none",
    border: '1px',
    width: '100%',
    height: '5.5rem',
    fontSize: theme.font.size14,
  },
  wordCountBox: {
    position: 'absolute',
    right: '1.25rem',
    bottom: '0.625rem',
    color: theme.color.text_color.grey,
    fontSize: theme.font.size12,
  },
  confirmButtonBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  // customerStar: {
  //   border: 'none',
  //   backgroundColor: 'transparent',
  //   width: '2rem',
  //   height: '2rem',
  //   backgroundRepeat: 'no-repeat',
  //   backgroundSize: '2rem',
  //   margin: '0 0.125rem',
  // },
  // starContainer: {
  //   display: 'flex',
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   cursor: 'pointer',
  //   gap: '0 4px',
  // },
  // starWrap: {
  //   '& .star': {
  //     width: '2rem',
  //     height: '2rem',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundSize: '2rem',
  //     backgroundImage: `url(${Star})`,
  //     border: 'none',
  //     backgroundColor: 'transparent',
  //     cursor: 'pointer',
  //   },
  //   '& .starFilled': {
  //     width: '2rem',
  //     height: '2rem',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundSize: '2rem',
  //     backgroundImage: `url(${StarSelected})`,
  //   },
  //   '& .starHalfFilled': {
  //     width: '2rem',
  //     height: '2rem',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundSize: '2rem',
  //     backgroundImage: `url(${StarHalf})`,
  //   },
  // },
  ratingCount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '0.625rem',
  },
  ratingButton: {
    width: '1.5rem',
    height: '1.5rem',
    border: 'none',
    borderRadius: '100%',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '1.5rem',
    textIndent: '-999999rem',
    margin: '0 0.625rem',
  },
  ratingMinusButton: {
    backgroundImage: `url(${CounterMinus})`,
  },
  ratingPlusButton: {
    backgroundImage: `url(${CounterPlus})`,
  },
});

function createOffsetMinute(date) {
  //분 단위로 계산
  var sign = date.getTimezoneOffset() > 0 ? '-' : '';
  var offset = Math.abs(date.getTimezoneOffset());

  return sign + offset;
}

// const CustomerStar = withStyles(styles)((props) => {
//   const { classes, type } = props;

//   return (
//     <div className={type === 'selected' ? classes.starSelected : classes.starNormal} />
//   );
// });

const CustomerFeedback = (props) => {
  const { classes, isLiveChat = false } = props;
  const data = useContext(DataContext);
  const [satisfiedCheck, setSatisfiedCheck] = useState(true);
  const [rating, setRating] = useState(10);
  // const [strRating, setStrRating] = useState(10);
  //  useState(
  //   data.string.customerfeedback.rating.excellent
  // );
  const [directInput, setDirectInput] = useState(false);
  const selectedFBInitial = {
    index: -1,
    text: 'N/A',
  };
  const [selectedFB, setSelectedFB] = useState(selectedFBInitial);
  const [userInput, setUserInput] = useState('');

  const maxInputLength = 400;

  const notGoodButtons = [
    data.string.customerfeedback.resultNotGood.notHelpful,
    data.string.customerfeedback.resultNotGood.dontUnderstand,
    data.string.customerfeedback.resultNotGood.error,
  ];
  const goodButtons = [
    data.string.customerfeedback.resultGood.helpful,
    data.string.customerfeedback.resultGood.understandWell,
    data.string.customerfeedback.resultGood.noError,
  ];

  // useEffect(() => {
  //   switch (rating) {
  //     case 0:
  //       setStrRating(0);
  //       // setStrRating(data.string.customerfeedback.rating.verypoor);
  //       break;
  //     case 1:
  //       setStrRating(1);
  //       // setStrRating(data.string.customerfeedback.rating.verypoor);
  //       break;
  //     case 2:
  //       setStrRating(2);
  //       // setStrRating(data.string.customerfeedback.rating.verypoor);
  //       break;
  //     case 3:
  //       setStrRating(3);
  //       // setStrRating(data.string.customerfeedback.rating.verypoor);
  //       break;
  //     case 4:
  //       setStrRating(4);
  //       // setStrRating(data.string.customerfeedback.rating.poor);
  //       break;
  //     case 5:
  //       setStrRating(5);
  //       // setStrRating(data.string.customerfeedback.rating.poor);
  //       break;
  //     case 6:
  //       setStrRating(6);
  //       // setStrRating(data.string.customerfeedback.rating.good);
  //       break;
  //     case 7:
  //       setStrRating(7);
  //       // setStrRating(data.string.customerfeedback.rating.good);
  //       break;
  //     case 8:
  //       setStrRating(8);
  //       // setStrRating(data.string.customerfeedback.rating.verygood);
  //       break;
  //     case 9:
  //       setStrRating(9);
  //       // setStrRating(data.string.customerfeedback.rating.verygood);
  //       break;
  //     case 10:
  //       setStrRating(10);
  //       // setStrRating(data.string.customerfeedback.rating.excellent);
  //       break;
  //     default:
  //       setStrRating(10);
  //       // setStrRating(data.string.customerfeedback.rating.excellent);
  //       break;
  //   }
  // }, [rating]);

  const modalRef = useRef();

  useEffect(() => {
    if (data.openCustomerFeedback) {
      setSatisfiedCheck(true);
      setRating(10);
      // setStrRating(10);
      // setStrRating(data.string.customerfeedback.rating.excellent);
      data.sendUserActionToApp(false);

      // 웹접근성 - 모달팝업 포커스 25-01
      const { current: modalElement } = modalRef;
      window.setTimeout(() => {
        modalElement.focus();
      });
    }
  }, [data.openCustomerFeedback]);

  const handleSatisfied = (satisfied) => {
    setSatisfiedCheck(satisfied);
  };

  // const handleRating = (_, star) => {
  //   if (star) setRating(star);
  // };

  const handleDiscard = async () => {
    const body = {
      branch: data.countryCode === 'kr' ? 'LGEKR' : 'LGEAI',
      country_code: data.countryCode,
      user_id: '', //data.userNo, //thinq survey needs mbr number but not lge.com
      rating: 10, // NPS로직관련 수정의 건 '나가기' 클릭시 default 10으로 수정
      utc_offset: createOffsetMinute(new Date()),
      satisfaction: 'na',
      livechat_yn: isLiveChat ? 'Y' : 'N',
      submit_yn: 'N',
      selected_idx: selectedFB.index,
      selected_txt: selectedFB.text,
      input_txt: userInput || 'N/A',
    };
    const res = await postLog(data, 'surveys', body);
    console.log('[CustomerFeedback] Discard', res);
    data.setOpenCustomerFeedback(false);

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  const handleSubmit = async () => {
    const body = {
      branch: data.countryCode === 'kr' ? 'LGEKR' : 'LGEAI',
      country_code: data.countryCode,
      user_id: '', //data.userNo, //thinq survey needs mbr number but not lge.com
      rating: rating,
      utc_offset: createOffsetMinute(new Date()),
      satisfaction: satisfiedCheck ? 'yes' : 'no',
      livechat_yn: isLiveChat ? 'Y' : 'N',
      submit_yn: 'Y',
      selected_idx: selectedFB.index,
      selected_txt: selectedFB.text,
      input_txt: userInput || 'N/A',
    };
    const res = await postLog(data, 'surveys', body);
    console.log('[CustomerFeedback] Result', res);
    data.setOpenCustomerFeedback(false);

    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }
  };

  const handleClose = () => {
    const rootChild = document.getElementById('root');
    const focusableElements = rootChild.querySelectorAll('*');

    for (let i = 0; i < focusableElements.length; i++) {
      focusableElements[i].removeAttribute('aria-hidden');
    }

    data.setOpenCustomerFeedback(false, true);
    data.sendUserActionToApp(true);
  };

  const inputHandler = (event) => {
    setUserInput(event.target.value);
  };

  const ratingCriteria = 6;

  const directInputOnly = satisfiedCheck
    ? rating <= ratingCriteria // 6점이하 satisfiedCheck true 예
    : rating > ratingCriteria; // 6점이상 satisfiedCheck false 아니오

  // const MakeStar = () => {
  //   // const [selectedRating, setSelectedRating] = useState(null);

  //   // const handleStarHover = (rating) => {
  //   //   setSelectedRating(rating);
  //   // };

  //   const handleStarClick = (star) => {
  //     setRating(star);
  //     console.log('Selected Rating:', star);
  //   };

  //   return (
  //     <div>
  //       {[1, 2, 3, 4, 5].map((star, index) => (
  //         <button
  //           key={`star-${index}`}
  //           onClick={() => handleStarClick(star)}
  //           className={classes.customerStar}
  //           style={
  //             rating && star <= rating
  //               ? {
  //                   backgroundImage: `url(${StarSelected})`,
  //                 }
  //               : {
  //                   backgroundImage: `url(${StarNormal})`,
  //                 }
  //           }
  //         ></button>
  //       ))}
  //       <div className={classes.ratingString}>{strRating}</div>
  //     </div>
  //   );
  // };

  // NPS 방식의 만족도 평가를 위한 챗봇 UI 개선 25-01
  const [btnActive, setBtnActive] = useState(10);

  const handleStarButtonClick = (e) => {
    const newRating = parseInt(e);
    // console.log('handleStarButtonClick : newRating ::::::', newRating);

    setRating(newRating);
    setBtnActive(() => {
      return newRating;
    });
  };

  const handleCountButtonClick = (rating, counter) => {
    const numRating = parseInt(rating);
    const numCounter = parseInt(counter);
    let numResult = numRating + numCounter;

    if (numResult > 10) {
      numResult = numResult - 1;
    } else if (numResult < 0) {
      numResult = numResult + 1;
    }

    handleStarButtonClick(numResult);
  };

  return createPortal(
    <div className={classes.root}>
      {data.openCustomerFeedback && (
        <div className={classes.dialogRoot} id="customerFeedback">
          <div
            className={classes.dialogContainerBackdrop}
            aria-hidden="true"
            onClick={handleClose}
          ></div>
          <div className={classes.dialogContainer}>
            <div className={classes.dialogBody}>
              {/* <Dialog
            classes={{
              root: classes.dialogRoot,
              paper: classes.dialogBody,
              container: classes.dialogContainer,
            }}
            open={data.openCustomerFeedback}
            onClose={handleClose}
            id={'customer_feedback'}
          > */}
              <h1 className={classes.title} ref={modalRef} tabIndex="0">
                {data.string.customerfeedback.title}
              </h1>
              {/* <Divider className={classes.divider} component={"div"} disabled /> */}
              <DialogContent classes={{ root: classes.dialogContent }}>
                <div className={classes.question}>
                  {data.string.customerfeedback.question1}
                </div>
                <div className={classes.satisfiedContainer}>
                  <button
                    className={[
                      classes.buttonSatisfed,
                      !satisfiedCheck
                        ? classes.buttonSatisfedOn
                        : classes.buttonSatisfedOff,
                    ].join(' ')}
                    onClick={() => {
                      setSelectedFB(selectedFBInitial);
                      handleSatisfied(false);
                    }}
                    title={!satisfiedCheck ? '선택됨' : ''}
                  >
                    {data.string.customerfeedback.unsatisfied}
                  </button>
                  <button
                    className={[
                      classes.buttonSatisfed,
                      satisfiedCheck
                        ? classes.buttonSatisfedOn
                        : classes.buttonSatisfedOff,
                    ].join(' ')}
                    onClick={() => {
                      setSelectedFB(selectedFBInitial);
                      handleSatisfied(true);
                    }}
                    title={satisfiedCheck ? '선택됨' : ''}
                  >
                    {data.string.customerfeedback.satisfied}
                  </button>
                </div>
                <div className={`${classes.question} ${classes.questionMargin}`}>
                  {data.string.customerfeedback.question2}
                </div>

                <div className={classes.ratingContainer}>
                  {/* NPS 방식의 만족도 평가를 위한 챗봇 UI 개선 25-01 */}
                  {/* <StarRating
                    setRating={setRating}
                    handleStarButtonClick={handleStarButtonClick}
                    btnActive={btnActive}
                  /> 
                  <div className={classes.ratingCount}>
                    <button
                      className={`${classes.ratingButton} ${classes.ratingMinusButton}`}
                      onClick={() => {
                        handleCountButtonClick(rating, -1);
                        // setRatingCount(btnActive);
                      }}
                    >
                      -1점
                    </button>
                    <div className={classes.ratingString}>{rating}</div>
                    <button
                      className={`${classes.ratingButton} ${classes.ratingPlusButton}`}
                      onClick={() => {
                        handleCountButtonClick(rating, +1);
                        // setRatingCount(btnActive);
                      }}
                    >
                      +1점
                    </button>
                  </div>
                  */}

                  {/* NPS UI 수정 요청의 건 25-05 */}
                  <NpsRating
                    setRating={setRating}
                    handleStarButtonClick={handleStarButtonClick}
                    btnActive={btnActive}
                  />

                  {/* <MakeStar /> */}
                  {/*  <Rating
                    value={rating}
                    onChange={handleRating}
                    defaultValue={5}
                    size="large"
                    icon={<CustomerStar type={'selected'} />}
                    emptyIcon={<CustomerStar type={'normal'} />}
                  /> */}
                </div>
                <div
                  className={`${classes.lastQuestionContainer} ${classes.questionMargin}`}
                >
                  <div className={`${classes.question} `}>
                    {/* {satisfiedCheck */}
                    {rating > ratingCriteria
                      ? data.string.customerfeedback.question3_1 // 어떤 점이 만족스러우셨나요? : 어떤 점이 불만족스러우셨나요?
                      : data.string.customerfeedback.question3_2}
                  </div>
                  {directInputOnly === false && (
                    <button
                      onClick={() => {
                        setDirectInput(!directInput);
                      }}
                      className={classes.toggleInput}
                    >
                      <img src={ToggleInput} className={classes.toggleIcon} alt="" />
                      {'직접입력'}
                    </button>
                  )}
                </div>
                <div className={classes.feedbackInputContainer}>
                  {!directInputOnly && directInput === false ? (
                    (satisfiedCheck ? goodButtons : notGoodButtons).map(
                      (buttonText, index) => (
                        <button
                          key={`cbtn_${index}`}
                          className={`${classes.fbBut} ${
                            selectedFB.index === index
                              ? classes.fbButSelected
                              : classes.fbButNotSelected
                          }`}
                          title={selectedFB.index === index ? '선택됨' : ''}
                          onClick={() => setSelectedFB({ index, text: buttonText })}
                        >
                          {buttonText}
                        </button>
                      )
                    )
                  ) : (
                    <div className={classes.directInputBox}>
                      <label htmlFor="directInputStyle" />
                      <textarea
                        id="directInputStyle"
                        title="의견 직접입력"
                        onChange={inputHandler}
                        maxLength={maxInputLength}
                        className={classes.directInputStyle}
                        // placeholder={satisfiedCheck?data.string.customerfeedback.resultGood.inputPlaceholder:data.string.customerfeedback.resultNotGood.inputPlaceholder}
                        placeholder={
                          rating > ratingCriteria
                            ? data.string.customerfeedback.resultGood.inputPlaceholder
                            : data.string.customerfeedback.resultNotGood.inputPlaceholder
                        }
                      >
                        {userInput}
                      </textarea>
                      <div className={classes.wordCountBox}>
                        <span>{userInput.length}</span>
                        <span>/{maxInputLength}자</span>
                      </div>
                    </div>
                  )}
                </div>
              </DialogContent>
              <DialogActions>
                <div className={classes.confirmButtonBox}>
                  <button
                    className={`${classes.button} ${classes.buttonSubmit}`}
                    onClick={handleSubmit}
                  >
                    {data.string.customerfeedback.submit}
                  </button>
                  <button
                    className={`${classes.button} ${classes.buttonDiscard}`}
                    onClick={handleDiscard}
                  >
                    {data.string.customerfeedback.discard}
                  </button>
                </div>
              </DialogActions>
            </div>
          </div>
        </div>
      )}
    </div>,
    document.getElementById('modal')
  );
};

export default withStyles(styles)(CustomerFeedback);
